import { render, staticRenderFns } from "./Supplycategory.vue?vue&type=template&id=0b49a3bf"
import script from "./Supplycategory.vue?vue&type=script&lang=js"
export * from "./Supplycategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports